import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-5 md:gap-6',
    button: 'w-full max-md:mt-3 md:max-w-[200px]'
  },
  variants: {},
  defaultVariants: {}
});
